export default function loadDate(datum){
    return new Date(datum*1000).toLocaleDateString("es-US") ;
};